import { useAuthStore } from '@/stores/authStore'
import { useChangePasswordStore } from '@/stores/changePasswordStore'
import { useCommonStore } from '@/stores/commonStore'
import { useErrorsStore } from '@/stores/errorsStore'
import { useOnboardingStore } from '@/stores/onboardingStore'
import { useUserStore } from '@/stores/userStore'
import { useStageStore } from '@/stores/stageStore'

import { useCookies } from '@vueuse/integrations/useCookies'
import router from '@/routes/index.js'

const $cookies = useCookies(['token', 'refresh_token'])

export function useAuth() {
  const resetAllStoresStates = () => {
    useAuthStore().$reset()
    useChangePasswordStore().$reset()
    useCommonStore().$reset()
    useErrorsStore().$reset()
    useOnboardingStore().$reset()
    useUserStore().$reset()
    useStageStore().$reset()
  }

  const signOut = async (redirectPayload = {}) => {
    resetAllStoresStates()
    localStorage.removeItem('refresh_token')
    $cookies.remove('refresh_token')
    await router.push({ name: 'Login', query: { ...redirectPayload } })
  }

  return {
    signOut
  }
}
